// safeArea.js
export class SafeAreaManager {
    static instance = null;

    constructor() {
        console.log('🔨 SafeAreaManager 构造函数执行');
        this.values = { left: 0, right: 0, top: 0, bottom: 0 };
        this.lastOrientation = '';
        this.calculationTimeout = null;
        this.lastCalculation = 0; // 🔥 添加这个
        this.init();
    }
    static getInstance() {
        console.log('🔧 获取 SafeAreaManager 实例');
        if (!SafeAreaManager.instance) {
            SafeAreaManager.instance = new SafeAreaManager();
        }
        return SafeAreaManager.instance;
    }

    // 检测设备类型
    detectDevice() {
        const ua = navigator.userAgent;
        return {
            isIOS: /iPad|iPhone|iPod/.test(ua),
            isAndroid: /Android/.test(ua),
            isDesktop: !/Android|iPad|iPhone|iPod/.test(ua)
        };
    }
    calculateIOS() {
        let left = 0, right = 0, top = 0, bottom = 0;
      
        if (CSS.supports('padding-top: env(safe-area-inset-top)')) {
          const temp = document.createElement('div');
          temp.style.cssText = `
            position: fixed;
            padding: env(safe-area-inset-top)
                     env(safe-area-inset-right)
                     env(safe-area-inset-bottom)
                     env(safe-area-inset-left);
            visibility: hidden;
          `;
          document.body.appendChild(temp);
      
          try {
            const style = window.getComputedStyle(temp);
      
            // 用 parseFloat 更稳（有些场景可能出现小数）
            left = parseFloat(style.paddingLeft) || 0;
            right = parseFloat(style.paddingRight) || 0;
            top = parseFloat(style.paddingTop) || 0;
            bottom = parseFloat(style.paddingBottom) || 0;
          } finally {
            document.body.removeChild(temp);
          }
        }
      
        const isLandscape = window.matchMedia('(orientation: landscape)').matches;
      
        // ✅ 横屏只保留 left，其它都为 0
        if (isLandscape) {
          return { left, right: 0, top: 0, bottom: 0 };
        }
      
        // ✅ 竖屏只保留上下，其它为 0
        return { left: 0, right: 0, top, bottom };
      }
      

    // 安卓横屏状态栏动态检测
    getAndroidLandscapeStatusBar() {
        console.log('🚀 开始动态检测安卓横屏状态栏');

        let statusBarHeight = 0;
        const detectionLogs = [];

        // 1. visualViewport.offsetLeft 检测
        if (window.visualViewport && window.visualViewport.offsetLeft > 0) {
            statusBarHeight = window.visualViewport.offsetLeft;
            detectionLogs.push(`visualViewport: ${statusBarHeight}px`);
        }

        // 2. screen.availLeft 检测
        if (window.screen.availLeft && window.screen.availLeft > statusBarHeight) {
            statusBarHeight = window.screen.availLeft;
            detectionLogs.push(`screen.availLeft: ${statusBarHeight}px`);
        }

        // 3. 屏幕宽度差值检测
        const screenWidth = Math.max(window.screen.width, window.screen.height);
        const windowWidth = window.innerWidth;
        const widthDiff = screenWidth - windowWidth;

        if (widthDiff > 0 && widthDiff < 100) {
            statusBarHeight = Math.max(statusBarHeight, widthDiff);
            detectionLogs.push(`宽度差值: ${widthDiff}px`);
        }

        // 4. 元素位置检测
        const testElement = document.createElement('div');
        testElement.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 1px;
            height: 1px;
            visibility: hidden;
        `;
        document.body.appendChild(testElement);
        const rect = testElement.getBoundingClientRect();
        document.body.removeChild(testElement);

        if (rect.left > 0) {
            statusBarHeight = Math.max(statusBarHeight, rect.left);
            detectionLogs.push(`元素位置: ${rect.left}px`);
        }

        console.log('📱 检测方法:', detectionLogs);

        // 5. 如果检测不到，使用DPI动态估算
        if (statusBarHeight <= 0) {
            statusBarHeight = this.estimateByDPI();
            console.log(`📱 使用DPI估算: ${statusBarHeight}px`);
        }

        console.log(`✅ 安卓横屏状态栏: ${statusBarHeight}px`);
        return statusBarHeight;
    }

    // 根据DPI动态估算
    estimateByDPI() {
        const dpr = window.devicePixelRatio || 1;
        console.log('📱 设备DPI:', dpr);

        // 根据设备像素比动态估算
        if (dpr >= 4) return 48;
        if (dpr >= 3.5) return 44;
        if (dpr >= 3) return 40;
        if (dpr >= 2.5) return 36;
        if (dpr >= 2) return 32;
        return 28;
    }

    getAndroidSafeArea() {
        const isLandscape = window.matchMedia('(orientation: landscape)').matches;

        if (isLandscape) {
            const statusBarHeight = this.getAndroidLandscapeStatusBar();
            return {
                left: statusBarHeight,
                right: 0,
                top: 0,
                bottom: 0
            };
        } else {
            return this.getAndroidPortraitStatusBar();
        }
    }

    getAndroidPortraitStatusBar() {
        let top = 0;

        if (window.screen.availTop && window.screen.availTop > 0) {
            top = window.screen.availTop;
        } else if (window.innerHeight < window.screen.height) {
            top = window.screen.height - window.innerHeight;
        } else {
            top = 24; // 默认值
        }

        console.log(`📱 安卓竖屏状态栏: ${top}px`);
        return { left: 0, right: 0, top, bottom: 0 };
    }
    calculate(force = false) {
        const now = Date.now();

        // 🔥 防抖：1秒内不重复计算，除非 force 为 true
        if (!force && now - this.lastCalculation < 1000) {
            console.log('⏰ 1秒内已计算过，跳过');
            return this.values;
        }

        console.log('🎯 执行计算');

        // 清除之前的定时器
        if (this.calculationTimeout) {
            clearTimeout(this.calculationTimeout);
        }

        // 延迟计算，确保页面稳定
        this.calculationTimeout = setTimeout(() => {
            this._doCalculate();
            this.lastCalculation = Date.now();
        }, 50);

        return this.values;
    }

    _doCalculate() {
        const device = this.detectDevice();
        const isLandscape = window.matchMedia('(orientation: landscape)').matches;
        console.log(`📱 _doCalculate 参数: iOS=${device.isIOS}, 横屏=${isLandscape}`);

        let result = { left: 0, right: 0, top: 0, bottom: 0 };

        if (device.isIOS) {
            console.log('📱 开始调用 calculateIOS()');
            result = this.calculateIOS();
            console.log('📱 calculateIOS() 返回值:', result);
        } else if (device.isAndroid) {
            console.log('📱 开始调用 getAndroidSafeArea()');
            result = this.getAndroidSafeArea();
        }

        // 🔥 只有值变化时才更新 DOM
        if (JSON.stringify(this.values) !== JSON.stringify(result)) {
            this.values = result;
            console.log('📱 值变化，更新:', this.values);
            this.updateCSSVariables();
        } else {
            console.log('📱 值未变化，跳过更新');
        }
    }

    // 精简 updateCSSVariables，只负责设置 CSS
    updateCSSVariables() {
        const root = document.documentElement;
        const { left, right, top, bottom } = this.values;
        const device = this.detectDevice();
        const isLandscape = window.matchMedia('(orientation: landscape)').matches;

        let outLeft = left;
        let outRight = 0;
        let outTop = 0;
        let outBottom = 0;

        if (device.isIOS) {
            if (isLandscape) {
                // ✅ 横屏：只要左侧
                outLeft = left;
                outRight = 0;
                outTop = 0;
                outBottom = 0;
            } else {
                // ✅ 竖屏：只要上下
                outLeft = 0;
                outRight = 0;
                outTop = top;
                outBottom = bottom;
            }
        } else {
            // 安卓或其他，直接使用计算出的值（安卓逻辑已在 calculate 中处理）
            outLeft = left;
            outTop = top;
            outRight = right;
            outBottom = bottom;
        }

        // 🔥 打印设置前的值，方便调试
        console.log(`🎨 设置 CSS: L=${outLeft}, R=${outRight}, T=${outTop}, B=${outBottom}`);

        root.style.setProperty('--safe-area-left', `${outLeft}px`);
        root.style.setProperty('--safe-area-right', `${outRight}px`);
        root.style.setProperty('--safe-area-top', `${outTop}px`);
        root.style.setProperty('--safe-area-bottom', `${outBottom}px`);
    }

    init() {
        console.log('🚀 init() 执行');

        // 立即计算一次
        this.calculate(true);
        this.lastOrientation = this.getCurrentOrientation();

        // 1. 监听屏幕变化
        const handleResize = () => {
            console.log('🔄 resize 触发');
            setTimeout(() => this.calculate(), 100);
        };

        // 2. 监听横竖屏切换
        const handleOrientationChange = () => {
            console.log('🔄 orientationchange 触发');
            setTimeout(() => this.calculate(), 300);
        };

        // 3. 🔥 关键：监听页面可见性
        const handleVisibilityChange = () => {
            if (!document.hidden) {
                console.log('👀 页面可见，检查方向变化');

                const currentOrientation = this.getCurrentOrientation();
                if (currentOrientation !== this.lastOrientation) {
                    console.log(`🔄 方向变化: ${this.lastOrientation} -> ${currentOrientation}`);
                    setTimeout(() => this.calculate(), 200);
                }
                this.lastOrientation = currentOrientation;
            }
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleOrientationChange);
        document.addEventListener('visibilitychange', handleVisibilityChange);

        // 4. 🔥 监听页面焦点
        window.addEventListener('focus', () => {
            console.log('🎯 页面获得焦点');
            setTimeout(() => this.calculate(), 100);
        });
    }

    getCurrentOrientation() {
        return window.matchMedia('(orientation: landscape)').matches ? 'landscape' : 'portrait';
    }


    getValues() {
        return this.values;
    }
}


export const safeArea = SafeAreaManager.getInstance();